export const EULA_FORM_ID = '1Zqj1YKQnVoR8L4OVhuZIag3OcU4MLL7YWcdwAT37rQ4';
